export default "__VITE_ASSET__BO6wHgof__"